import * as React from 'react';
import { Box, Button, Divider, Grid, TextField } from '@mui/material';

import { usePasswordFormManager } from './password-form.hook';

interface PasswordFormProps {
  onLoading?: (loading: boolean) => void;
  next?: (data?: any) => void;
}

export const PasswordForm = React.forwardRef(({ onLoading = () => {}, next }: PasswordFormProps, ref) => {
  const [formManager, { isLoading }] = usePasswordFormManager({ next });

  React.useImperativeHandle(ref, () => ({ onSubmit: () => formManager.handleSubmit() }), []);

  React.useEffect(() => onLoading(isLoading), [isLoading]);

  return (
    <form onSubmit={formManager.handleSubmit}>
      <Box paddingY={2}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <TextField
              label="Old Password"
              type="password"
              variant="outlined"
              fullWidth
              onChange={formManager.handleChange('old_password')}
              error={!!(formManager.errors.old_password && formManager.touched.old_password)}
              helperText={formManager.touched.old_password ? formManager.errors.old_password : null}
            />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="New Password"
              type="password"
              variant="outlined"
              fullWidth
              onChange={formManager.handleChange('new_password')}
              error={!!(formManager.errors.new_password && formManager.touched.new_password)}
              helperText={formManager.touched.new_password ? formManager.errors.new_password : null}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Password Confirm"
              type="password"
              variant="outlined"
              fullWidth
              onChange={formManager.handleChange('new_password_confirm')}
              error={!!(formManager.errors.new_password_confirm && formManager.touched.new_password_confirm)}
              helperText={formManager.touched.new_password_confirm ? formManager.errors.new_password_confirm : null}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} hidden>
          <Button type="submit" variant="contained" fullWidth>
            Submit
          </Button>
        </Grid>
      </Box>
    </form>
  );
});
